
export interface IGlobalContext {
    offlineMode: boolean;
    /** На устройстве есть хотя бы один скачанный трек library_music (native). */
    hasOfflineLibraryMusic: boolean;
    prevRoute?: string;
    isManager: boolean;
    isMobile: boolean;
    musicBeta: boolean;
    videoBeta: boolean;
    showMenuNotification: boolean;
    isLoading: boolean;
    syncVideoGuide: boolean;
    medicalBookExpired: boolean;
}

export class GlobalContext implements IGlobalContext {
    offlineMode = false;
    hasOfflineLibraryMusic = false;
    prevRoute = '';
    isManager = false;
    isMobile = false;
    musicBeta = false;
    videoBeta = false;
    showMenuNotification = false;
    isLoading = false;
    syncVideoGuide = false;
    medicalBookExpired = false;

    constructor() {
    }
}
